type FilterColumnProps = {
    style?: React.CSSProperties;
}
export const FilterColumnsIcon = ({ style }: FilterColumnProps): JSX.Element => (
  <svg style={style} width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.00032 14.3333L6.00033 1M10.667 12.3333L10.667 3M1.33366 12.3333L1.33366 3" stroke="#363BC4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
